import React from 'react';
import { Award, Calendar, MapPin } from 'lucide-react';
import '../../styles/ExperienceSection.css';

const ExperienceSection = ({ data }) => {
  return (
    <section className="experience-section section-animate">
      <div className="container">
        <h2 className="section-title">Expérience & Réalisations</h2>
        
        <div className="experience-timeline">
          {data.achievements.map((achievement, index) => (
            <div key={index} className="timeline-item" style={{
              animationDelay: `${index * 0.2}s`
            }}>
              <div className="timeline-marker">
                <Award className="marker-icon" />
              </div>
              
              <div className="timeline-content">
                <div className="timeline-header">
                  <h3>{achievement.title}</h3>
                  <span className="timeline-period">
                    <Calendar className="period-icon" />
                    {achievement.period}
                  </span>
                </div>
                
                <p className="timeline-description">
                  {achievement.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;